import { i18next } from '@frontend/i18n';

export const SidePanel = {
  Numbers: i18next.t('Phone Numbers and Extensions', { ns: 'phone' }),
  Location: i18next.t('Location', { ns: 'phone' }),
  PhoneHours: i18next.t('Phone Hours', { ns: 'phone' }),
  Override: i18next.t('Override', { ns: 'phone' }),
} as const;

export type SidePanelType = (typeof SidePanel)[keyof typeof SidePanel];
